import { Component } from '@angular/core';

import { ChdNavigationMenuMaterialRenderer } from '@cp-produkte/cruise-hospitality-design';

import { BackendToggleComponent } from '../backend-toggle/backend-toggle.component';

@Component({
  selector: 'spa-chd-navigation-menu-material-renderer',
  imports: [BackendToggleComponent, ChdNavigationMenuMaterialRenderer],
  templateUrl: './chd-navigation-menu-material-spa-renderer.component.html',
  styleUrl: './chd-navigation-menu-material-spa-renderer.component.scss',
})
export class ChdNavigationMenuMaterialSpaRenderer {}
